<template>
    <el-button type="warning" plain  icon="el-icon-upload el-icon--right" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'import-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "导入"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// ImportButton.vue?7138a208